import { NeoModel, ModelBase, Attributes, Misc, Validation } from "@singularsystems/neo-core";
import { ExportEventTypeEnum } from "../Enums/ExportEventTypeEnum";

@NeoModel
export default class SaveFileGroupingExportSettingCommand extends ModelBase {
    public staticServiceProviderFileGroupingExportSettingId: number | null = null;

    public staticServiceProviderFileGroupingId: number | null = null;

    public staticExportEventTypeId: number | null = null;

    public exportEventType: ExportEventTypeEnum | null = ExportEventTypeEnum.Export;

    public eventType: ExportEventTypeEnum | null = ExportEventTypeEnum.Export;

    public dayOfWeek: string = "";

    @Attributes.Date(Misc.TimeZoneFormat.None)
    public eventTime: Date | null = null;

    public eventTimeString: string = "";

    protected override addBusinessRules(validationRules: Validation.Rules<this>): void {
        super.addBusinessRules(validationRules);

        validationRules.failWhen((command: this) => !command.eventTime, "Event Time is required.");
        validationRules.failWhen((command: this) => !command.exportEventType, "Event Type is required.");
        validationRules.failWhen((command: this) => !command.dayOfWeek || command.dayOfWeek.length === 0, "Please select at least one day of the week.");
    }
}